// extracted by mini-css-extract-plugin
export default {"cls1":"SearchUpsell-cls1_YPW","cls2":"SearchUpsell-cls2__UR SearchUpsell-cls1_YPW"};